import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import Dashboard from 'views/application/hostel/Dashboard';
import StudentDetails from 'views/application/hostel/students/StudentDetails';
import StaffHostelDetail from 'views/application/hostel/staff-allocated';
import HostelReports from 'views/application/hostel/reports';

const HostelSetupAdd = Loadable(lazy(() => import('views/application/hostel/hostelsetup/index')));
const HostelSetupEdit = Loadable(lazy(() => import('views/application/hostel/hostelsetup/HostelEdit')));
const RoomCategoryAdd = Loadable(lazy(() => import('views/application/hostel/roomcategorysetup/index')));
const RoomSetupAdd = Loadable(lazy(() => import('views/application/hostel/roomsetup/index')));
const RoomSetupEdit = Loadable(lazy(() => import('views/application/hostel/roomsetup/RoomEdit')));
const HostelStudentAllocation = Loadable(lazy(() => import('views/application/hostel/studentallocation/index')));
const HostelStaffAllocation = Loadable(lazy(() => import('views/application/hostel/staff-allocation/index')));
const HostelFeeAllocation = Loadable(lazy(() => import('views/application/hostel/hostelfeeallocation/index')));
const ActiveQRCode = Loadable(lazy(() => import('views/application/hostel/hostelsetup/ActiveQRCode')));
const ActiveQRCodeDetails = Loadable(lazy(() => import('views/application/hostel/hostelsetup/ActiveQRCodeEdit')));
const HostelCheckOutList = Loadable(lazy(() => import('views/application/hostel/HostelCheckOutList')));
const HostelCheckOutStudentProfile = Loadable(lazy(() => import('views/application/hostel/CheckOutStudentProfile.')));
const HostelCheckOutApprovedStudentList = Loadable(lazy(() => import('views/application/hostel/CheckOutRequestApprovedList')));
const HostelDiscontinuedStudentList = Loadable(lazy(() => import('views/application/hostel/students/DiscontinueHostelList')));
const StudentHosteOverDueReport = Loadable(lazy(() => import('views/application/hostel/StudentHostelOverDueReport')));
const StudentHosteMontlyOverDueReport = Loadable(lazy(() => import('views/application/hostel/HostelMonthlyFeeDueReport')));
const HostelAttendanceReport = Loadable(lazy(() => import('views/application/hostel/reports/HostelAttendanceReport')));
const HostelActiveCollection = Loadable(lazy(() => import('views/application/hostel/hostelActiveCollection/HostelActiveCollection')));
const HostelCurrentMonthCollection = Loadable(lazy(() => import('views/application/hostel/hostelCurentMonthCollection/index')));
const HostelDailyActiveCollection = Loadable(
    lazy(() => import('views/application/hostel/hostelActiveCollection/DailyHostelCollectionReport'))
);
const HostePrevioustMonthCollection = Loadable(
    lazy(() => import('views/application/hostel/hostelCurentMonthCollection/HostelPreviosMonthDue'))
);
const HostelRoomViewReport = Loadable(lazy(() => import('views/application/hostel/hostelRoomView/index')));
const HostelFeeFineSetup = Loadable(lazy(() => import('views/application/hostel/hostelfeeFine/index')));
const HostelWithdrawFine = Loadable(lazy(() => import('views/application/hostel/hostelRevokeFine/HostelWithdrawFine')));
const HostelCollectionSechule = Loadable(lazy(() => import('views/application/hostel/hostelCollectionSchedule/index')));

const roles = ['ROLE_ADMIN', 'ROLE_COLLEGE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_COLLEGE_SUB_ADMIN'];

const HostelRoutes = {
    path: '/',
    element: (
        <AuthGuard roles={roles}>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/hostel/dashboard',
            element: <Dashboard />
        },
        {
            path: '/hostel/buildings/add',
            element: <HostelSetupAdd />
        },
        {
            path: '/hostel/active/collection',
            element: <HostelActiveCollection />
        },
        {
            path: '/hostel/daily/fee/collection',
            element: <HostelDailyActiveCollection />
        },
        {
            path: '/hostel/buildings/edit/:id',
            element: <HostelSetupEdit />
        },
        {
            path: '/room/category/add',
            element: <RoomCategoryAdd />
        },
        {
            path: '/hostel/rooms/add',
            element: <RoomSetupAdd />
        },
        {
            path: '/hostel/rooms/edit/:id',
            element: <RoomSetupEdit />
        },
        {
            path: '/hostel/student/allocation',
            element: <HostelStudentAllocation />
        },
        {
            path: '/hostel/staff/allocation',
            element: <HostelStaffAllocation />
        },
        {
            path: '/hostel/student/allocation/:buildingId/:floorNumber',
            element: <HostelStudentAllocation />
        },
        {
            path: '/hostel/fee/allocation',
            element: <HostelFeeAllocation />
        },
        {
            path: '/hostel/reports',
            element: <HostelReports />
        },
        {
            path: '/hostel/student/details/:buildingId/:floorNumber/:room',
            element: <StudentDetails />
        },
        {
            path: '/hostel/student/details',
            element: <StudentDetails />
        },
        {
            path: '/hostel/staff/details',
            element: <StaffHostelDetail />
        },
        {
            path: '/active/QR/code/:id',
            element: <ActiveQRCode />
        },
        {
            path: '/active/QR/code/details/:id',
            element: <ActiveQRCodeDetails />
        },
        {
            path: '/hostel/checkout/list',
            element: <HostelCheckOutList />
        },
        {
            path: '/hostel/checkout/student/profile/:id',
            element: <HostelCheckOutStudentProfile />
        },
        {
            path: '/hostel/checkout/approved/student/list',
            element: <HostelCheckOutApprovedStudentList />
        },
        {
            path: '/hostel/discontinued/students/list',
            element: <HostelDiscontinuedStudentList />
        },
        {
            path: '/student/hostel/overdue/report',
            element: <StudentHosteOverDueReport />
        },
        {
            path: '/student/hostel/monthly/overdue/report',
            element: <StudentHosteMontlyOverDueReport />
        },
        {
            path: '/hostel/attendance/report',
            element: <HostelAttendanceReport />
        },
        {
            path: '/hostel/current/month/collection',
            element: <HostelCurrentMonthCollection />
        },
        {
            path: '/hostel/previous/month/collection',
            element: <HostePrevioustMonthCollection />
        },
        {
            path: '/hostel/room/view',
            element: <HostelRoomViewReport />
        },
        {
            path: '/hostel/feefine/setup',
            element: <HostelFeeFineSetup />
        },
        {
            path: '/hostel/revoke/feefine',
            element: <HostelWithdrawFine />
        },
        {
            path: '/hostel/collection/schedule',
            element: <HostelCollectionSechule />
        }
    ]
};
export default HostelRoutes;
